import React, { useEffect, useRef } from 'react'
import styles from './style.module.scss'
import { useMediaQuery } from 'react-responsive'

import navbarLogo from '../../Assets/Logo.jpg'
import { Link } from 'react-router-dom'

const Navbar = ({ active }) => {

	const topContainerRef = useRef(null);
	const bottomContainerListRef = useRef(null);
	const isMobile = useMediaQuery({ query: '(max-width: 850px)' })

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 50 && isMobile) {
				topContainerRef.current.style.height = '37px';
			} else if (window.scrollY > 50 && !isMobile) {
				topContainerRef.current.style.height = '0px';
			} else {
				topContainerRef.current.style.height = '80px';
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleMenuClick = () => {
		
		
		bottomContainerListRef.current.style.top = bottomContainerListRef.current.style.top === '37px' ? '-500px' : '37px';

		
	}

	return (
		<nav>
			<div className={styles.topContainer} ref={topContainerRef}>
				<img src={navbarLogo} alt="logo" />
			</div>
			{isMobile ? (
				<div className={styles.bottomContainer}>
					<div className={styles.menuIconCont} onClick={handleMenuClick}>
						<svg viewBox="0 0 100 80">
							<rect rx="10" width="100" height="20"></rect>
							<rect rx="10" y="30" width="100" height="20"></rect>
							<rect rx="10" y="60" width="100" height="20"></rect>
						</svg>
					</div>
					<ul ref={bottomContainerListRef}>
						<li className={active === "home" ? styles.active : ""}><Link to="/">Home</Link></li>
						<li className={active === "about-us" ? styles.active : ""}><Link to="/about-us">About Us</Link></li>
						<li className={active === "services-market" ? styles.active : ""}><Link to="/services-market">Services Market</Link></li>
						<li className={active === "fleet-details" ? styles.active : ""}><Link to="/fleet-details">Fleet Details</Link></li>
						<li className={active === "clients" ? styles.active : ""}><Link to="/clients">Clients</Link></li>
						<li className={active === "gallery" ? styles.active : ""}><Link to="/gallery">Gallery</Link></li>
						<li className={active === "testimonials" ? styles.active : ""}><Link to="/testimonials">Testimonials</Link></li>
						<li className={active === "contact" ? styles.active : ""}><Link to="/contact">Contact</Link></li>
					</ul>
				</div>
			) : (
				<div className={styles.bottomContainer}>
					<ul>
						<li className={active === "home" ? styles.active : ""}><Link to="/">Home</Link></li>
						<li className={active === "about-us" ? styles.active : ""}><Link to="/about-us">About Us</Link></li>
						<li className={active === "services-market" ? styles.active : ""}><Link to="/services-market">Services Market</Link></li>
						<li className={active === "fleet-details" ? styles.active : ""}><Link to="/fleet-details">Fleet Details</Link></li>
						<li className={active === "clients" ? styles.active : ""}><Link to="/clients">Clients</Link></li>
						<li className={active === "gallery" ? styles.active : ""}><Link to="/gallery">Gallery</Link></li>
						<li className={active === "testimonials" ? styles.active : ""}><Link to="/testimonials">Testimonials</Link></li>
						<li className={active === "contact" ? styles.active : ""}><Link to="/contact">Contact</Link></li>
					</ul>
				</div>
			)}
		</nav >
	)


}



export default Navbar